const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    productMedia: document.querySelector('[data-productMedia]')
  };

  const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
  window.productMedia = mediaJSON;
  class TemplateProductJS {
    constructor() {
      let thumb_image =  document.querySelectorAll('.product-thumb--image')
      thumb_image.forEach((target) =>{
        target.addEventListener('click', (event)=>{
          let thumb_img = event.currentTarget
          
          let opt_1 = thumb_img.querySelector('img').getAttribute('option_1');
          let opt_2 = thumb_img.querySelector('img').getAttribute('option_2');
          let opt_3 = thumb_img.querySelector('img').getAttribute('option_3');
          console.log(opt_1,"opt_1");
          if(opt_1 != ''){
            document.querySelector(`.swatch [value="${opt_1}"]`).checked = true;
            var event_1 = new Event('change', {
                bubbles: true,
                cancelable: true
            });
            document.querySelector(`.swatch [value="${opt_1}"]`).dispatchEvent(event_1);
            if(opt_2 != ''){
              document.querySelector(`.swatch [value="${opt_2}"]`).checked = true;
              var event_2 = new Event('change', {
                  bubbles: true,
                  cancelable: true
              });
              document.querySelector(`.swatch [value="${opt_2}"]`).dispatchEvent(event_2);
            }
            if(opt_3 != ''){
              document.querySelector(`.swatch [value="${opt_3}"]`).checked = true;
              var event_3 = new Event('change', {
                  bubbles: true,
                  cancelable: true
              });
              document.querySelector(`.swatch [value="${opt_3}"]`).dispatchEvent(event_3);
            }
          }
        });
      })
 
      // Custom code for product page goes here
      // document.querySelector('.read_more').addEventListener('click', (e)=>{
      //   e.preventDefault();
      //   let currentTarget = e.target;
      //   if(currentTarget.closest('[data-readmorecontainer]').classList.contains('open')){
      //     Utility.toggleElement(currentTarget.closest('[data-readmorecontainer]'), 'close');
      //     currentTarget.innerHTML = "Show more";
      //   }else{
      //     Utility.toggleElement(currentTarget.closest('[data-readmorecontainer]'), 'open');
      //     currentTarget.innerHTML = "Show Less";
      //   }
      // });
      // document.querySelectorAll(".hulkapps_swatch_option").forEach(ele =>{
      //   ele.addEventListener('click', (select)=>{
      //     select.preventDefault();
      //     var seleted_opt = select.currentTarget;
      //     let parent = seleted_opt.closest('.swatch_render');
      //    let span = `<span class="selected_var">${seleted_opt.querySelector('[data-hinventory]').getAttribute('value')}</span>`;
      //    if(parent.querySelector('.selected_var')){
      //     parent.querySelector('.selected_var').innerHTML = seleted_opt.querySelector('[data-hinventory]').getAttribute('value')
      //    }else{
      //     parent.querySelector('.hulkapps_option_name').insertAdjacentHTML('beforeend', span);
      //    }
      //   });
      // })

      // document.querySelector('.subscription-desc .block_show').addEventListener('click', () => {
      //   document.querySelector('.product-description-full').classList.remove("d-none");
      //   document.querySelector('.product-description-short').classList.add("d-none");
      // });
      // document.querySelector('.subscription-desc .block_hide').addEventListener('click', () => {
      //   document.querySelector('.product-description-full').classList.add("d-none");
      //   document.querySelector('.product-description-short').classList.remove("d-none");
      // });
    }
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();
